<template>
  <v-container
    id="trainings-view"
    fluid
    tag="section"
  >
    <material-card
      icon="$trainings"
      icon-small
      color="accent"
      :title="page_title"
      help="trainings"
    >
      <v-card-title>
        <v-btn
          v-show="editor"
          v-shortkey.once="['f2']"
          color="primary"
          class="mb-2"
          @shortkey="edit(-1)"
          @click="edit(-1)"
        >
          {{ $t('new_item',{ item: $t('training') }) }}
        </v-btn>
        <searcher
          type="trainings"
          @selected="selectTraining"
        />
        <v-row class="ma-0">
          <v-spacer v-if="!$vuetify.breakpoint.mdAndDown" />
          <v-text-field
            v-model="search"
            append-icon="$search"
            class="ml-auto"
            hide-details
            :label="$t('search_records')"
            single-line
          />
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-data-table
          :headers="computed_headers"
          :items="items"
          :loading="loading"
          :loading-text="$t('loading')"
          :options.sync="options"
          :server-items-length="total"
          :footer-props="footerProps"
        >
          <template #item.actions="{item}">
            <tooltip-btn
              v-if="editor && item.owner_organization_id === profile.organization.id"
              color="edit"
              icon="$edit"
              tooltip="tooltip_edit"
              @click="edit(item.id)"
            />
            <tooltip-btn
              v-for="(action, i) in actions"
              :key="i"
              :show="!action.disable"
              :color="action.color"
              :icon="action.icon"
              :tooltip="action.tooltip"
              :to="action.to ? action.to+item.id : ''"
              @click="action.func(item.id)"
            >
              <v-icon v-text="action.icon" />
            </tooltip-btn>
          </template>
        </v-data-table>
      </v-card-text>
    </material-card>
  </v-container>
</template>

<script>
  // Utilities
  import { get, call, sync, dispatch } from 'vuex-pathify'
  import Searcher from '@/layouts/default/infos/Searcher.vue'

  export default {
    name: 'Trainings',
    components: { Searcher },
    data () {
      return {
        items: [],
        // table
        footerProps: {
          itemsPerPageOptions: [10, 20, 25, 50, 100],
        },
        country: 'Hungary',
        total: 0,
        timer: null,
      }
    },
    computed: {
      loading: get('app/loading'),
      profile: get('auth/profile'),
      options: sync('training/options'),
      search: sync('training/search'),
      headers () {
        return [
          {
            text: this.$t('fields.code'),
            align: 'start',
            sortable: false,
            value: 'code',
          },
          {
            text: this.$t('fields.name'),
            align: 'start',
            sortable: false,
            value: 'name',
          },
          {
            hide_small: true,
            text: this.$t('fields.owner_organization'),
            sortable: false,
            value: 'owner_organization.name',
          },
          {
            text: this.$t('actions'),
            value: 'actions',
            sortable: false,
            align: 'right',
          },
        ]
      },
      actions () {
        return [
          // { color: 'info', icon: '$info' },
          // { color: 'edit', icon: '$edit', tooltip: 'tooltip_edit', func: this.edit, disable: !this.editor },
          { color: 'blue', icon: '$documents', tooltip: 'tooltip_documents', to: '/documents/training/' },
          { color: 'info', icon: '$list', tooltip: 'tooltip_show_tasks', func: this.showTasks },
        ]
      },
      page_title () { return this.$t('trainings') },
      editor () { return this.profile.can['training-edit-admin'] },
      computed_headers () { return this.headers.filter(h => h.hide_small !== this.$vuetify.breakpoint.mdAndDown) },
    },
    watch: {
      search: {
        handler () {
          if (this.timer) {
            clearTimeout(this.timer)
            this.timer = null
          }
          this.timer = setTimeout(() => {
            this.options.page = 1
            this.load()
          }, 800)
        },
        deep: true,
      },
      options: {
        handler () {
          this.load()
        },
        deep: true,
      },
      country: {
        handler () {
          this.load()
        },
        deep: true,
      },
    },
    mounted () {
      // this.load()
    },
    methods: {
      getList: call('training/search'),
      shareTrainingRequest: call('action/shareTrainingRequest'),
      async load () {
        try {
          const { sortBy, sortDesc, page, itemsPerPage } = this.options
          await this.getList({
            page: page,
            per_page: itemsPerPage,
            sort: {
              field: sortBy,
              order: sortDesc,
            },
            search: this.search,
            country: this.country,
          }).then(response => {
            this.items = response.data
            this.total = response.total
          }).catch(e => {
            console.log(e)
          })
        } catch (e) {
        }
      },
      edit (id) {
        this.$router.push(`/settings/training/${id}`).catch(() => {})
      },
      showTasks (id) {
        this.$router.push(`/settings/training/${id}/tasks`).catch(() => {})
      },
      async selectTraining (result) {
        await this.shareTrainingRequest(
          {
            organization_id: this.profile.organization.id,
            training_id: result.id,
          },
        ).then(response => {
          dispatch('alert/setSnackbar', { text: this.$t('send_shareTrainingRequest'), type: 'success' })
          this.load()
          this.closeDialog()
        }).catch(e => {
          console.log(e)
          this.$refs.dialog.setErrors(e)
        })
      },
    },
  }
</script>
